<template>
  <div class="p-party-selection-form g-page__row">
    <h3>{{ $t('createEnvelope.partySelectionForm.selectYourParties') }}</h3>
    <VPartySelection
      :documents="$store.state.envelopes.creating.envelope.documents"
      v-model="parties"
    />
    <div class="g-page__row__buttons p-party-selection-form__controls-container">
      <VMessage type="warning" subtype="outlined" class="p-party-selection-form__validation-message" v-show="!parties.isValid">
        <template v-slot:icon>
          <ExclamationTriangleIcon />
        </template>
        <template v-slot:text>
          {{ $t('envelope.party.partiesIncompleteMessage') }}
        </template>
      </VMessage>
      <VButton
        type="cta-3"
        class="float-right p-party-selection-form__next-button"
        :action="addParties"
        :loading="isLoading"
        :disabled="!parties.isValid"
        :title="parties.isValid ? '' : $t('envelope.party.partiesIncompleteMessage')"
        data-ec="envelope_send"
        data-et="party_next_step">
        <span>{{ $t('functional.nextStep') }}</span>
        <ArrowRightIcon />
      </VButton>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VPartySelection from '@/views/components/PartySelection.vue';
import { ArrowRightIcon, ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VPartySelectionForm',
  description: 'Used in EnvelopeCreate as a step linking parties and signing roles',
  components: {
    VButton,
    VMessage,
    VPartySelection,
    ArrowRightIcon,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      server: {
        calls: 0,
        loaded: 0,
      },
      parties: {},
    };
  },
  methods: {
    async addParties() {
      const parties = this.parties.array;

      try {
        this.server.calls += 1;
        await this.$store.dispatch('envelopes/ADD_PARTIES', { parties, isCreating: true });
        this.server.loaded += 1;
      } catch (error) {
        if (!error.response) throw error;
        this.server.loaded += 1;
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.fail.add', { name: 'parties' }), icon: 'times', type: 'error' }));
        return false;
      }

      const mergeFields = this.extractMergeFields(parties);

      if (mergeFields.length) {
        try {
          this.server.calls += 1;
          await this.$store.dispatch('envelopes/UPDATE_FIELDS', {
            fields: mergeFields,
            isCreating: true,
          });
          this.server.loaded += 1;
        } catch (error) {
          if (!error.response) throw error;
          this.server.loaded += 1;
          this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.fail.error', { action: 'populating the merge fields' }), icon: 'times', type: 'error' }));
        }
      }

      this.$emit('nextStep');
      return true;
    },
    extractMergeFields(parties) { // Extracts all merge fields, from all parties, as an array
      const mergeFields = [];
      parties.forEach((party) => {
        Object.values(party.mergeFields).forEach((contract) => {
          contract.forEach((item) => {
            const field = item;
            field.template_party_id = party.template_party_ids[contract.contractId]; // eslint-disable-line

            mergeFields.push(field);
          });
        });
      });

      const newParties = this.$store.state.envelopes.creating.envelope.parties;

      const fields = mergeFields.map((item) => {
        const field = item;
        newParties.forEach((party) => {
          if (party.template_party_ids) {
            party.template_party_ids.forEach((partyId) => {
              if (field.template_party_id === partyId) {
                field.party_id = party.id;
              }
            });
          }
        });
        return field;
      });

      return fields;
    },
  },
  computed: {
    isLoading() {
      return this.server.calls !== this.server.loaded;
    },
    validParties() {
      const isValidParty = party =>
        party.email &&
        party.title &&
        Object.keys(party.selected).length &&
        Object.keys(party.template_party_id).length;

      return this.parties.array && this.parties.array.filter(isValidParty).length === this.parties.array.length;
    },
  },
};
</script>

<style scoped>
.p-party-selection-form__controls-container {
  margin: -15px 0; /* need negative margin here otherwise spacing is inconsistent when button and message no longer fit on 1 line */
  padding-top: 0;
  border-top: 1px solid var(--color-border);
}
.p-party-selection-form__validation-message {
  vertical-align: middle;
  margin-top: var(--spacing-base);
}
.p-party-selection-form__next-button {
  margin: var(--spacing-base) 0 0 var(--spacing-base);
}
</style>
